import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/rich/tooltip';

import { Button, Typography } from './base';
import Icon, { ICON_TYPE } from './base/icon';
import { Photo } from './rich';

import { getImagePreview } from '../lib/imageTransformer';

const CLICK_TYPE = {
  SELECT: 'select',
  REMOVE: 'remove',
  DUPLICATE: 'duplicate',
};

const PhotoWellItem = forwardRef((props, ref) => {
  const isSelectable = !!props.onSelect;

  const handleOnClick = (e, type) => {
    e.preventDefault();

    if (isSelectable && type === CLICK_TYPE.SELECT) {
      props.onSelect();
    } else {
      e.stopPropagation();

      if (type === CLICK_TYPE.REMOVE) {
        props.onRemove();
      } else if (type === CLICK_TYPE.DUPLICATE) {
        props.onDuplicate();
      }
    }
  };

  let selectableProps = {};
  if (isSelectable) {
    selectableProps = {
      as: 'a',
      href: '#',
      onClick: e => handleOnClick(e, CLICK_TYPE.SELECT),
    };
  }

  let handleRemovePhoto;
  if (props.onRemove) {
    handleRemovePhoto = e => {
      handleOnClick(e, CLICK_TYPE.REMOVE);
    };
  }

  let handleDuplicatePhoto;
  if (props.onDuplicate) {
    handleDuplicatePhoto = e => {
      handleOnClick(e, CLICK_TYPE.DUPLICATE);
    };
  }

  return (
    <Photo.Item ref={ref} type={props.cover ? 'cover' : 'photo'}>
      <Photo.ImageWrapper>
        <Typography.Block
          {...selectableProps}
          style={{
            backgroundImage: `url(${getImagePreview(props.photo.url)})`,
            backgroundSize: 'contain',
            backgroundPosition: '50% 50%',
            backgroundRepeat: 'no-repeat',
          }}
        />
        <Photo.Buttons>
          <div>
            {(handleRemovePhoto || handleDuplicatePhoto) && (
              <>
                <Button
                  disabled={!handleDuplicatePhoto}
                  square
                  outline
                  onClick={handleDuplicatePhoto}
                  mb={1}
                >
                  <Icon type={ICON_TYPE.ADD} color="primary" width={10} height={10} />
                </Button>
                <Button disabled={!handleRemovePhoto} square outline onClick={handleRemovePhoto}>
                  <Icon type={ICON_TYPE.REMOVE} color="primary" width={10} height={10} />
                </Button>
              </>
            )}
          </div>

          <div>
            {props.pages.length > 0 && (
              <Tooltip placement="left" text="Photo is already used in your creation">
                <Button square outline mb={1} color="yellow" backgroundColor="yellowLight">
                  <Icon type={ICON_TYPE.BOOK} width={12} height={12} />
                </Button>
              </Tooltip>
            )}
            <Tooltip placement="left" text={`${props.photo.width} x ${props.photo.height}`}>
              <Button square outline>
                <Icon type={ICON_TYPE.INFO_TINY} color="primary" width={12} height={12} />
              </Button>
            </Tooltip>
          </div>
        </Photo.Buttons>
      </Photo.ImageWrapper>

      {props.cover && (
        <Typography.Heading size={4} style={{ textTransform: 'none' }}>
          Cover
        </Typography.Heading>
      )}
    </Photo.Item>
  );

  /*
  {props.photo.alive === -1 && (
    <Badge type="danger" className="badge-damaged-photo">
      Error Uploading
    </Badge>
  )}
  */
});

PhotoWellItem.propTypes = {
  photo: PropTypes.object,
  cover: PropTypes.bool,
  pages: PropTypes.array,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func,
  onDuplicate: PropTypes.func,
};

PhotoWellItem.defaultProps = {
  cover: false,
  pages: [],
};

export default PhotoWellItem;
